import type { ReactNode } from "react";

interface RestoreFromZipGateProps {
  access: "pro" | "trial_available" | "trial_used";
  children?: ReactNode;
  consumedAt?: string | null | undefined;
}

export function RestoreFromZipGate({
  access,
  children,
  consumedAt,
}: RestoreFromZipGateProps) {
  const usedAt = consumedAt
    ? new Date(consumedAt).toLocaleString()
    : "an earlier date";
  return (
    <section className="zip-recovery-workflow">
      {access === "trial_available" ? (
        <div className="zip-restore-trial-note">
          <strong>One ZIP restore included</strong>
          <p>
            Trial includes one restore from a Board Preserve Local Export or
            cloud-backup ZIP. It creates a new private recovery board and does
            not change the original board. It counts as used only after you
            confirm.
          </p>
        </div>
      ) : null}
      {access === "trial_used" ? (
        <div className="zip-restore-locked" role="status">
          <span className="feature-badge">Trial used</span>
          <h2>Your included ZIP restore has been used</h2>
          <p>
            This Workspace used its one included ZIP restore on {usedAt}. The
            recovery board stays in Trello. Board Preserve keeps its restore
            report for 30 days. Pro adds ongoing recovery from ZIP files and
            cloud backups.
          </p>
        </div>
      ) : (
        children
      )}
    </section>
  );
}
